// Расширенное предупреждение при аннулировании продления (решение USER
// 2026-07-21, см. постмортем nil-money-columns): оператор видит точные
// последствия ДО удаления — сколько вычтется, каким станет итог и к какой
// ставке откатится применяемая цена; плюс адаптивные предупреждения для
// ручных броней и отрицательного итога («клиенты творят что хотят» —
// не ищем логику в данных, предупреждаем о последствиях).
//
// Числа зеркалят серверный prolongs#destroy: units × new_price вычитаются
// из rental_cost/total, применяемая цена = new_price новейшего ОСТАВШЕГОСЯ
// продления, а для единственного — old_price удаляемого. FE позволяет
// удалить только новейшее продление (index == 0, не automatic), поэтому
// «ближайшее оставшееся» = предыдущий сегмент — откат всегда LIFO.
//
// ВАЖНО (XSS): результат уходит в $confirm({ html }) — интерполируются
// ТОЛЬКО числа (fmt) и $t-строки, никаких пользовательских текстов.

export function prolongUnits(prolong, booking) {
  if (booking.hourly) return { count: Number(prolong.prolong_hours) || 0, unitKey: "hourly" };
  if (booking.weekly) return { count: Number(prolong.prolong_weeks) || 0, unitKey: "weekly" };
  if (booking.monthly) return { count: Number(prolong.prolong_months) || 0, unitKey: "monthly" };
  return { count: Number(prolong.prolong_days) || 0, unitKey: "daily" };
}

// 38295.000000000004 -> 38295; 1233.333333 -> 1233.33
function fmt(value) {
  const n = Number(value) || 0;
  return Number.isInteger(n) ? n : Number(n.toFixed(2));
}

export function buildProlongAnnulWarning({ prolong, prolongs, booking, t, currency }) {
  const { count, unitKey } = prolongUnits(prolong, booking);
  const rate = fmt(prolong.new_price);
  const delta = fmt(count * rate);
  const total = fmt(booking.total);
  const newTotal = fmt(total - delta);
  const remaining = (prolongs || []).filter((p) => p.id !== prolong.id);
  const rollbackPrice = remaining.length > 0 ? fmt(remaining[0].new_price) : fmt(prolong.old_price);
  const cur = currency || "";

  const lines = [
    `<p>${t("prolongs.delete_prolong_warn")}</p>`,
    `<p>${t("prolongs.annul_warn_amount", {
      count, unit: t(`prolongs.annul_units_${unitKey}`), rate, delta, currency: cur
    })}</p>`,
    `<p>${t("prolongs.annul_warn_total", { total, new_total: newTotal, currency: cur })}</p>`,
    `<p>${t("prolongs.annul_warn_price", { price: rollbackPrice, currency: cur })}</p>`,
  ];
  if (booking.manual_editing) {
    lines.push(`<p class="warning--text font-weight-bold">${t("prolongs.annul_warn_manual")}</p>`);
  }
  if (newTotal < 0) {
    lines.push(`<p class="error--text font-weight-bold">${t("prolongs.annul_warn_negative", {
      new_total: newTotal, currency: cur
    })}</p>`);
  }
  return lines.join("");
}
